interface Props {
  width?: number;
  height?: number;
  hexColor?: string;
  title?: string
}

export const CartBag = ({
  width = 20,
  height = 20,
  hexColor = '#000000',
}: Props) => {
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.3359 7.50033V5.00033C13.3359 3.15938 11.8435 1.66699 10.0026 1.66699C8.16164 1.66699 6.66925 3.15938 6.66925 5.00033V7.50032M2.99592 8.62696L2.49592 13.9603C2.35376 15.4767 2.28268 16.2349 2.53429 16.8206C2.75533 17.335 3.14269 17.7604 3.63427 18.0285C4.19386 18.3337 4.95539 18.3337 6.47846 18.3337H13.5267C15.0498 18.3337 15.8113 18.3337 16.3709 18.0285C16.8625 17.7604 17.2498 17.335 17.4709 16.8206C17.7225 16.2349 17.6514 15.4767 17.5093 13.9603L17.0093 8.62696C16.8892 7.34645 16.8292 6.70619 16.5412 6.22213C16.2876 5.79581 15.9129 5.45458 15.4647 5.24186C14.9559 5.00033 14.3128 5.00033 13.0267 5.00033L6.97846 5.00033C5.69233 5.00033 5.04926 5.00033 4.54044 5.24186C4.09231 5.45458 3.71759 5.79581 3.46397 6.22213C3.176 6.70619 3.11597 7.34645 2.99592 8.62696Z" stroke={hexColor} strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};

export default CartBag;
